import Cookies from 'js-cookie'
import constants from '@/utils/constants'
import JwtDecode from 'jwt-decode'

const TOKEN_NAME = constants.TOKEN_NAME || 'user_token'

// token 信息
export const getToken = () => {
  let token = Cookies.get(TOKEN_NAME)
  if (token) {
    const info = JwtDecode(token)
    const dateTime = Date.now()
    const timestamp = Math.floor(dateTime / 1000)
    if (info.exp < timestamp) {
      token = ''
    }
  } else {
    token = ''
  }
  return token
}

export const setToken = (token) => {
  return Cookies.set(TOKEN_NAME, token)
}

export const removeToken = () => {
  return Cookies.remove(TOKEN_NAME)
}
